import type { ProductWithCategories } from '@/lib/api/products';
import type { Product } from '@/types';

// Admin changes can affect checkout even when price/name stay the same: a set
// can become the set of the day, or change availability/category/recipe.
export function sameCartProduct(
  stored: ProductWithCategories | Product,
  fresh: ProductWithCategories
) {
  const keys = [
    'sku',
    'price',
    'name',
    'image_url',
    'black_url',
    'status',
    'is_visible',
    'categories',
    'is_set_of_the_day',
    'ingredients',
    'allergens',
    'weight',
    'description',
    'is_new',
    'is_popular',
    'is_riceless',
    'is_scorched',
    'is_mini',
    'spiciness',
  ] as const;
  return keys.every(
    (key) =>
      JSON.stringify((stored as unknown as Record<string, unknown>)[key]) ===
      JSON.stringify(fresh[key])
  );
}
